export default __webpack_public_path__ + "static/media/Nigeria-Food-market.7df94b40.webp";